
<div class="col-12 my-1" *ngFor="let file of FileList">
    <file-attachment-display
            [FileAttachment]="file"
            [EditMode]="EditMode"
            (Delete)="DeleteFile(file)">
    </file-attachment-display>
</div>
<div class="col-12 my-1">
    <file-attachment-input
            *ngIf="EditMode"
            [UploadHandler]="FileUploader()">
    </file-attachment-input>
</div>